// Dependencies
import request from 'oc-request';
import Alpine from "alpinejs";

// General code

document.querySelectorAll('.js-form')
    .forEach((form) => {
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            request.sendForm(event.target, `${event.target.id}::onFormSubmit`, {
                success(response) {
                    Alpine.store('popups').closeAll();
                    Alpine.store('popups').show('popup-thanks');
                    event.target.reset();
                },
                error(response) {
                    Alpine.store('popups').closeAll();
                    Alpine.store('popups').show('popup-error');
                }
            });
        });
    });